import { ComponentProps, useCallback } from "react";
import { useClearRefinements, useSearchBox } from "react-instantsearch";

import { cn } from "@tudigo-monorepo/core-tudigo-theme";
import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";
import { SearchBar } from "@tudigo-monorepo/web-tudigo-components";

export const CustomSearchBar = ({
  className,
  ...props
}: ComponentProps<"div">) => {
  const { query, refine, clear } = useSearchBox();
  const { refine: clearRefinements, canRefine } = useClearRefinements();
  const { t } = useTranslation();

  const handleSearch = useCallback(
    (newQuery: string) => {
      refine(newQuery);
      if (canRefine) {
        clearRefinements();
      }
    },
    [refine, clearRefinements, canRefine],
  );

  return (
    <div className={cn("relative w-full md:w-60", className)} {...props}>
      <SearchBar
        placeholder={t(
          "search_projects_page.financed.header.search_input.placeholder",
        )}
        onSearchChange={handleSearch}
        value={query}
        onClear={clear}
      />
    </div>
  );
};
